import { useMutation } from '@apollo/react-hooks';
import { useState } from 'react'
import { UPDATE_PASSWORD_USER } from './queries';
import { useToasts } from 'react-toast-notifications';
import { PAYMENT_GATEWAY_ENABLED } from '@dhn/shared/payment-gateway';

const INITIAL_STATE = {
    isOpenModalSecurity: false,
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    differentInputPassword: false,
    saving: false,
}

export default function useActions() {
    const [state, setState] = useState(INITIAL_STATE);
    const [action] = useMutation(UPDATE_PASSWORD_USER);
    const { addToast } = useToasts();
    const bodyItem = [{ name: "Seguridad", icon: "fa fa-shield", key: "isOpenModalSecurity", permission: 'security', value: true },
        { name: "Mis consultorios", nav: "/centers", icon: "fa fa-building", permission: 'centers' },
        { name: "Mis Parámetros Médicos", nav: "/medical-parameters", icon: "fa fa-cogs", permission: 'medical-parameters' },
        { name: "Mis especialidades", nav: "/medical-specialities", icon: "fa fa-graduation-cap", permission: 'medical-specialities' },
        { name: "Mis Servicios", nav: "/medical-services", icon: "fa fa-user-md", permission: 'medical-services' },
        PAYMENT_GATEWAY_ENABLED && { name: "Mis métodos de Pago", nav: "/payment-methods", icon: "fa fa-credit-card-alt", permission: 'payment-methods' }].filter(Boolean)

    const toggle = () => {
        setState(() => ({
            ...INITIAL_STATE
        }))
    }

    const onChange = (key, value) => {
        setState(prev => ({
            ...prev,
            [key]: value,
            differentInputPassword: state.differentInputPassword && false
        }))
    }

    const onModifiyPassword = async () => {
        if (state.saving) return;
        try {
            const regex = /^(?=.*[A-Z])(?=.*[\W_]).{6,}$/;

            if (!state.currentPassword) {
                return addToast('Debe ingresar la contraseña actual.', { appearance: 'error', autoDismiss: true });
            }

            if (state.confirmPassword !== state.newPassword) {
                setState(prev => ({ ...prev, differentInputPassword: true }))
                return addToast('Los campos password no coinciden.', { appearance: 'error', autoDismiss: true });
            }

            if (!regex.test(state?.newPassword)) {
                setState(prev => ({ ...prev, differentInputPassword: true }))
                return addToast(`Por favor, asegúrese de que la contraseña tenga más de 5 caracteres,
                              incluya al menos un carácter especial y contenga al menos una letra mayúscula.
                              Gracias por su colaboración.`, { appearance: 'error', autoDismiss: true });
            }

            setState(prev => ({ ...prev, saving: true }))
            await action({
                variables: {
                    data: {
                        currentPassword: state.currentPassword,
                        password: state.newPassword
                    }
                },
            });

            toggle();
            addToast('Modificación Exitosa.', { appearance: 'success', autoDismiss: true });
        } catch (error) {
            setState(prev => ({ ...prev, saving: false }))
            addToast(error.message, { appearance: 'error', autoDismiss: true });
        }
    }
    return [{ state, bodyItem }, { onChange, toggle, onModifiyPassword, addToast }]
}
